import * as z from "zod";

export const getAdjustmentReportCount = {
  name: "getAdjustmentReportCount" as const,
  input: z.object({ search: z.string().optional() }),
  output: z.object({ total: z.number() }),
};
